import { useTheme } from './ThemeProvider';

import logoDark from '../assets/logo_dark.png';
import logoLight from '../assets/logo_light.png';

interface LogoProps {
  className?: string;
  height?: number;
  variant?: 'light' | 'dark' | 'auto';
}

export const Logo = ({
  className = '',
  height = 32,
  variant = 'auto'
}: LogoProps) => {
  const { variant: themeVariant } = useTheme();

  const isDark = variant === 'auto' ? themeVariant === 'dark' : variant === 'dark';
  const src = isDark ? logoDark : logoLight;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={src}
        alt="FONGPT"
        width={height}
        className="h-auto object-contain"
      />
    </div>
  );
};

export default Logo;
